import { Product } from "../product/product";
import { Resource } from "../resource";

export class CampaignType extends Resource {
    type: string;
    name: string;
    value: number;
}

export class DiscountCampaign extends Resource {
    discount: number;
    campaign: CampaignType
    oldPrice: number;
    price: number;
    priceToPay: number;
    product: Product;    
    quantity: number;    
    sku: string;    
}